<template>
  <div
    v-show="isCompactView"
    id="abbreviatedNavigationBar"
    v-debug-highlight="{color: '#4d97c8'}"
    qaid="nav-compact-container"
    class="nav-compact-container"
  >
    <div class="title-bar row" data-responsive-toggle="none" data-hide-for="large">
      <div class="title-bar__icon title-bar__icon-menu">
        <button
          :class="`nav-compact-container__icon ${mobileMenuOpen ? 'open' : ''}`"
          type="button"
          :aria-label="menuAriaLabel"
          :name="menuName"
          @click="toggleMobileMenu"
        ></button>
      </div>
      <div class="title-bar__logo">
        <slot name="logo" />
      </div>
      <div class="title-bar__icon title-bar__icon-search">
        <label :id="isB2b ? 'mobile-header-search-button' : null" class="js-site-search-icon">
          <a :class="isB2b ? 'text-white' : 'primary-navigation__primary-item__icon-link'">
            <i class="material-icons md-24">search</i>
          </a>
        </label>
      </div>
      <div class="title-bar__icon title-bar__icon-cart">
        <slot name="cart" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'NavCompactContainer',
  props: {
    isB2b: {
      type: Boolean,
      default: false,
    },
    menuAriaLabel: {
      type: String,
      default: null,
    },
    menuName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    ...mapState('navigation', ['mobileMenuOpen']),
  },
  methods: {
    ...mapMutations('navigation', ['setMobileMenuOpen']),
    toggleMobileMenu() {
      this.mobileMenuOpen ? this.setMobileMenuOpen(false) : this.setMobileMenuOpen(true);
    },
  },
};
</script>

<style scoped lang="scss">
.nav-compact-container {
  /* This is a duplication of the hamburger-icon styles in _navigation.scss. It was very difficult to include the various scss files needed

  to get the mixin to work, and since this will be replaced with an icon component in phase 2, this was the easiest approach. */

  /* TODO: Replace this custom css with an icon component in phase 2 */

  &__icon {
    &::before {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 24px; /* Preferred icon size */
      display: inline-block;
      line-height: 1;
      text-transform: none;
      letter-spacing: normal;
      word-wrap: normal;
      white-space: nowrap;
      direction: ltr;

      /* Support for all WebKit browsers. */
      -webkit-font-smoothing: antialiased;

      /* Support for Safari and Chrome. */
      text-rendering: optimizeLegibility;

      /* Support for Firefox. */
      -moz-osx-font-smoothing: grayscale;

      /* Support for IE. */
      font-feature-settings: 'liga';
      font-size: 1.5rem;
      height: 1.5rem;
      width: 1.5rem;
      content: 'menu';
    }

    &.open {
      &::before {
        content: 'close';
      }
    }
  }
}
</style>
